import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { getBirthData } from '../lib/auth';

const RequireBirthData = ({ children }) => {
  const [user, setUser] = useState(null);
  const [hasBirthData, setHasBirthData] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkBirthData = async () => {
      if (!supabase) {
        setLoading(false);
        return;
      }

      try {
        // Hae käyttäjä
        const { data: { user: currentUser } } = await supabase.auth.getUser();
        if (!currentUser) {
          setLoading(false);
          return;
        }

        setUser(currentUser);

        // Hae birth_data
        const { data: birthData } = await getBirthData(currentUser.id);
        setHasBirthData(!!birthData);
      } catch (error) {
        console.error('RequireBirthData: Error:', error);
        setHasBirthData(false);
      } finally {
        setLoading(false);
      }
    };

    checkBirthData();
  }, []);

  if (loading) {
    return (
      <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="moon-loader">
          <div className="moon"></div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasBirthData) {
    return <Navigate to="/profile-setup" replace />;
  }

  return children;
};

export default RequireBirthData;
